export default __webpack_public_path__ + "static/media/fill-form.f49ff57e.svg";